import React, { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import classnames from 'classnames';
import { truncate } from 'lodash';
import useMediaQuery from 'react-use-media-query-hook';

import CustomerSegmentCard from '../../main/containers/customerSegment/CardTech';
import { COLORS, TECH_MODERN_TEMPLATE_NAME } from '../../main/utils/const';
import SectionHeaderWeb from '../../main/components/SectionHeaderWeb';

const { white } = COLORS;
const IMAGE_CUSTOMER_ASPECT_RATIO = 1 / 1.35;

const CustomerSegment = ({
  locales,
  locales: {
    portfolioWeb,
    customerSegment: {
      intro: { card },
    },
  },
  titleColor,
  borderCardColor,
  backgroundImage,
  background,
}) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [activeCardId, setActiveCardId] = useState(null);
  const { customerSegment } = useSelector((state) => state.portfolio);

  const { collection } = useSelector((state) => state.customerSegment);

  const activeCardData = useMemo(() => {
    if (collection.length && !activeCardId) {
      setActiveCardId(collection[0].id);
      return collection[0];
    }
    return collection.find((i) => i.id === activeCardId);
  }, [collection, activeCardId]);

  const singleCard = activeCardData && (
    <CustomerSegmentCard
      locales={locales}
      isPreview
      background={white}
      backgroundImage={backgroundImage}
      borderCardColor={borderCardColor}
      aspectRatio={IMAGE_CUSTOMER_ASPECT_RATIO}
      card={{
        ...card,
        ...activeCardData,
        subtitle: activeCardData.name,
        title: null,
      }}
    />
  );
  return (
    <div
      className="customer-segment-tech-web section-web"
      style={{ backgroundColor: background }}
    >
      <SectionHeaderWeb
        templateName={TECH_MODERN_TEMPLATE_NAME}
        title={portfolioWeb.customerSegment}
        description={customerSegment.description}
        portfolioWeb={portfolioWeb}
        style={{ color: titleColor }}
      />

      <div className="cards-section">
        <div className="left">
          {collection.map(({ id, name }) => (
            <div
              key={id}
              onClick={() => setActiveCardId(id)}
              className={classnames('item', { active: activeCardId === id })}
            >
              {truncate(name, { length: 45 })}
            </div>
          ))}
        </div>
        <div className="right">
          {isMobile
            ? collection.map((customerSegmentItem) => {
                return (
                  <CustomerSegmentCard
                    locales={locales}
                    isPreview
                    background={white}
                    backgroundImage={backgroundImage}
                    borderCardColor={borderCardColor}
                    aspectRatio={IMAGE_CUSTOMER_ASPECT_RATIO}
                    card={{
                      ...card,
                      ...customerSegmentItem,
                      subtitle: customerSegmentItem.name,
                      title: null,
                    }}
                  />
                );
              })
            : singleCard}
        </div>
      </div>
    </div>
  );
};

export default CustomerSegment;
